/** The sign-out form's endpoint (`src/routes/sign-out.ts`) and its field for where to go next. */
export const SIGN_OUT_PATH = "/sign-out";
export const SIGN_OUT_REDIRECT_FIELD = "redirectTo";

/** Where sign-out sends people: a path on this site (its query kept), else the home page. */
export const signOutRedirectTarget = (value: unknown): string =>
  typeof value === "string" && /^\/(?![/\\])[^\u0000-\u001f\u007f]*$/.test(value) ? value : "/";

/**
 * Signs out with a document request: the browser posts the sign-out form, and the response that
 * deletes the session cookies redirects to `redirectTo`, which then loads signed out. A fragment
 * (such as an invitation token) stays in the browser: it goes on the form's address, which the
 * redirect inherits, never to the server.
 */
export const submitSignOut = (redirectTo = "/") => {
  const hashIndex = redirectTo.indexOf("#");
  const path = hashIndex === -1 ? redirectTo : redirectTo.slice(0, hashIndex);
  const hash = hashIndex === -1 ? "" : redirectTo.slice(hashIndex);
  const form = document.createElement("form");
  form.method = "post";
  form.action = `${SIGN_OUT_PATH}${hash}`;
  form.hidden = true;
  const field = document.createElement("input");
  field.type = "hidden";
  field.name = SIGN_OUT_REDIRECT_FIELD;
  field.value = path || "/";
  form.append(field);
  document.body.append(form);
  form.submit();
};
